export const apiEndpoints = {
  productActions: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/products`,
  },
  aiVideoGeneration: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/ai-video-generation`,
  },
  accountActions: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/accounts`,
  },
  uploadUrl: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/upload`,
  },
  publishActions: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/publish`,
  },
  shopify: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/shopify`,
  },
  payment: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/payment`,
  },
  studio: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/studio`,
  },
  accountService: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/account-service`,
  },
  resolveAll: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/features-resolver`,
  },
  tiktok: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/tiktok`,
  },
  productsService: {
    endpoint: `${process.env.NEXT_PUBLIC_API_URL}/products-service`,
  },
};
